import { makeRequired } from 'CorePackage/MainModule/validators/isRequired';
import { IKnmFormDocument } from 'KnmPackage/KnmDocumentsModule/interfaces/IKnmFormDocument';
import { FormErrors } from 'KnmPackage/MainModule/types/FormErrors';

export const getDocumentsValidate = (
  documents: (IKnmFormDocument | undefined)[] | undefined,
  isIntegrationCategoryValidate: boolean,
): FormErrors<IKnmFormDocument>[] | undefined => {
  return documents?.map(item => ({
    type: makeRequired('Поле не может быть пустым')(item?.type),
    attachments: isIntegrationCategoryValidate
      ? makeRequired('Поле не может быть пустым')(item?.attachments)
      : undefined,
  }));
};
